import { render, staticRenderFns } from "./chatMovement.vue?vue&type=template&id=8f2f58ca&scoped=true&"
import script from "./chatMovement.vue?vue&type=script&lang=js&"
export * from "./chatMovement.vue?vue&type=script&lang=js&"
import style0 from "./chatMovement.vue?vue&type=style&index=0&id=8f2f58ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f2f58ca",
  null
  
)

export default component.exports